/**
 * @fileoverview GET handler for the "/apps/:app_group_id/teams/:team_id/summary" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError, reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdTeamsTeamIdSummary } from "./constants";
import type { GetTeamSummaryError, TeamSummaryResponse } from "./types";
import { isTeamSummaryResponse } from "./validators";

export const getTeamSummary = reactQueryFetcherAdapter(
  appsAppGroupIdTeamsTeamIdSummary,
  createGetFetcherFunctionWithShadowError<GetTeamSummaryError>()(
    (signal: AbortSignal, appGroupId: string, teamId: string): Promise<TeamSummaryResponse> => {
      return fetch(`/apps/${appGroupId}/teams/${teamId}/summary`, "GET", {}, { signal });
    }
  ),
  isTeamSummaryResponse
);
